import type { PropsWithChildren } from 'react';
import React from 'react';

import { Loader } from '@change-corgi/design-system/components/progressiveDisclosure';

import { withPrefetchedData } from 'src/shared/prefetch';

import { isLoading } from 'src/app/shared/utils/async';

import { prefetch } from './prefetch';
import { useFcm } from './shared/fcm';
import type { DefaultLayoutProps } from './shared/types';
import { LayoutV1 } from './v1';
import { LayoutV2 } from './v2';

export const DefaultLayout = withPrefetchedData(
	({
		children,
		...props
	}: PropsWithChildren<DefaultLayoutProps> & { suppressHydrationWarning?: boolean }): React.JSX.Element | null => {
		const fcm = useFcm();

		if (isLoading(fcm)) {
			return <Loader size="m" my={256} mx="auto" />;
		}

		const Layout = fcm.values.frameRelaunch ? LayoutV2 : LayoutV1;

		return <Layout {...props}>{children}</Layout>;
	},
	{
		prefetchName: __MODULE_HASH__,
		prefetchData: async (context) => {
			await prefetch(context);
		},
	},
);
